import cn from 'classnames';
import React, {ReactNode, FC} from 'react';

import {ButtonsBar} from '../buttons-bar';
import {ILinkButtonProps} from '../link-button';
import {DictionaryIcons, TDictionaryIconsMap} from './layout-icons.constants';

import './widget-layout.less';

interface IWidgetLayoutProps {
    children?: ReactNode;
    title?: string;
    buttons?: {
        top?: ILinkButtonProps[];
        bottom?: ILinkButtonProps[];
    };
    className?: string;
    iconName?: string;
    iconsMap?: TDictionaryIconsMap;
    properties?: {
        isWithWrap?: boolean;
        isJustified?: boolean;
        isWithAutoOverflow?: boolean;
    };
}
export const WidgetLayout: FC<IWidgetLayoutProps> = ({
    children, title, buttons, iconName, className, properties = {}, iconsMap = DictionaryIcons,
}: IWidgetLayoutProps) => {
    const {isWithWrap, isJustified, isWithAutoOverflow} = properties;

    const Icon = iconName ? iconsMap[iconName] : null;

    return (
        <div className={cn('widget-layout', className)}>
            { Icon && (
                <div className={cn('widget-layout__icon')}><Icon /></div>
            )}
            <div className={cn('widget-layout__up-bar')}>
                <div className={cn('widget-layout__up-bar__title')}>
                    {title}
                </div>
                {buttons?.top && <div className={cn('widget-layout__up-bar__bar')} />}
                <div className={cn('widget-layout__up-bar__buttons')}>
                    <ButtonsBar buttons={buttons?.top} />
                </div>
            </div>
            <div className={cn('widget-layout__body', {
                'widget-layout__body_with-wrap': isWithWrap,
                'widget-layout__body_justified': isJustified,
                'widget-layout__body_with-auto-overflow': isWithAutoOverflow,
            })}
            >
                {children}
            </div>
            <div className={cn('widget-layout__footer')}>
                <ButtonsBar buttons={buttons?.bottom} />
            </div>
        </div>
    );
};
